import { createSlice } from '@reduxjs/toolkit'
import { BUSINESS_PROFILE_REDUCER } from '../../../constants/redux'

const initialFormattedData = {
  businessDescription: '',
  businessHandle: '',
  businessName: '',
  businessAddress: {},
  contactInfo: {
    businessEmail: '',
    businessPhoneNumber: '',
    businessWebsiteUrl: '',
  },
  allContactInfo: {},
  coverPhoto: '',
  profilePhoto: '',
  profilePreferences: {
    locationDisplayPreference: '',
    emailAddressDisplay: false,
    phoneNumberDisplay: false,
    websiteDisplay: false,
  },
}

export const initialBusinessProfileReduxState = {
  profileData: null,
  isPreviewing: false,
  saveStatus: 'idle',
  uneditedFormattedData: { ...initialFormattedData },
  editedProfileData: {
    errorMessage: '',
    areValuesEdited: false,
    values: { ...initialFormattedData },
  },
}

const businessProfileSlice = createSlice({
  reducers: {
    updateProfileData: (state, action) => {
      state.profileData = action.payload
    },
    updateIsPreviewing: (state, action) => {
      state.isPreviewing = action.payload
    },
    setSaveStatus: (state, action) => {
      state.saveStatus = action.payload
    },
    updateAreValuesEdited: (state, action) => {
      state.editedProfileData.areValuesEdited = action.payload
    },
    updateUneditedFormattedData: (state, action) => {
      state.uneditedFormattedData = {
        ...state.uneditedFormattedData,
        ...action.payload,
      }
    },
    updateEditedProfileDataValues: (state, action) => {
      state.editedProfileData.values = {
        ...state.editedProfileData.values,
        ...action.payload,
      }
    },
    updateEditedProfilePreferencesDataValues: (state, action) => {
      state.editedProfileData.values.profilePreferences = {
        ...state.editedProfileData.values.profilePreferences,
        ...action.payload,
      }
    },
    updateSubscription: (state, action) => {
      state.profileData.isSubscribed = action.payload
    },
    updateEditPageErrorMessage: (state, action) => {
      state.editedProfileData.errorMessage = action.payload
    },
  },
  name: BUSINESS_PROFILE_REDUCER,
  initialState: initialBusinessProfileReduxState,
})

export const {
  updateProfileData,
  updateIsPreviewing,
  setSaveStatus,
  updateAreValuesEdited,
  updateEditedProfileDataValues,
  updateEditedProfilePreferencesDataValues,
  updateSubscription,
  updateEditPageErrorMessage,
  updateUneditedFormattedData,
} = businessProfileSlice.actions

export default businessProfileSlice.reducer
